import { GlobalStyles, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Theme-aware styling for the `react-verification-input` library, whose DOM and
 * `.vi__*` class names we cannot control directly. Shared by every code-entry
 * screen (login 2FA, password-reset 2FA, guest document access, change-phone).
 *
 * Replaces the former `styles/verificationInput.scss` so the styling lives in
 * the MUI theme system (tokens via `theme.palette`) ahead of the scss removal.
 */
const VerificationInputGlobalStyles = (): JSX.Element => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        '.vi__container': {
          width: '100%',
          height: 64,
          gap: 10,
          justifyContent: 'center',
        },
        '.vi__container input.vi': {
          opacity: 0,
        },
        '.vi__character': {
          flex: '0 0 auto',
          borderRadius: 12,
          width: 48,
          height: 64,
          color: alpha(theme.palette.primary.darker, 0.8),
          fontSize: 26,
          lineHeight: '60px',
          cursor: 'pointer',
          borderColor: theme.palette.divider,
          backgroundColor: 'transparent',
        },
        '.vi__character:nth-of-type(4)': {
          position: 'relative',
          marginLeft: 50,
        },
        '.vi__character:nth-of-type(4)::before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '-24px',
          width: '0.75rem',
          height: 2,
          backgroundColor: alpha(theme.palette.primary.darker, 0.2),
          transform: 'translate(-0.875rem, -50%)',
        },
        '.vi__character--selected': {
          outline: 'none',
          borderWidth: 2,
          borderColor: theme.palette.primary.main,
          boxShadow: `0 0 0 2px ${theme.palette.custom.brand[25]}`,
        },
        '.vi__character--filled': {
          borderWidth: 2,
          borderColor: theme.palette.primary.main,
        },
      }}
    />
  );
};

export default VerificationInputGlobalStyles;
